import React, { useState, useEffect, useRef } from "react";
import { RiArrowDropDownLine } from "react-icons/ri";
import ResponseMsg2 from '../../general/ResponseMsg2'
import axios from 'axios'
import HeadingArea from "../../general/HeadingArea";
import { FaCheck } from "react-icons/fa";


const AddHomework = ({ setLoading }) => {
    //updated state
    const [classes, setClasses] = useState([]);
    const [availableSections, setAvailableSections] = useState([]);
    const [selectedClassId, setSelectedClassId] = useState('');
    const [academicYears, setAcademicYears] = useState([]);
    const [subjects, setSubjects] = useState([]);
    const [response2, setResponse2] = useState({ message: '', status: 'success' });

    const [form, setForm] = useState({
        homework_date: '',
        submisssion_date: '',
        marks: '',
        description: '',
        classes: '',
        section: '',
        subject: '',
        year:'',
        file: null,
    })
    const fileInputRef = useRef(null);




    const fetchAcademicYears = async () => {
        setLoading(true);
        try {
            const response = await fetch('https://api.kcian.in/get-academic-years');
            if (response.ok) {
                const data = await response.json();
                setAcademicYears(data);
            } else {
                console.error('Failed to fetch academic years');
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };
    
console.log(academicYears);

    const fetchClasses = async () => {
        setLoading(true);
        try {
            const response = await fetch('https://api.kcian.in/get-classes');
            if (response.ok) {
                const data = await response.json();
                setClasses(data);
            } else {
                console.error('Failed to fetch class');
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        fetchClasses();
        fetchAcademicYears();
    }, []);



useEffect(() => {
    const selectedClass = classes.find((cls) => cls.id === Number(form.classes));
    if (selectedClass && selectedClass.sections) {
        const sectionArray = selectedClass.sections
            .split(',')
            .map((s) => s.trim())
            .filter((s) => s !== '');
        setAvailableSections(sectionArray);
    } else {
        setAvailableSections([]);
    }

    setForm(prev => ({ ...prev, section: '' }));
    setSubjects([]);

    if (form.classes) {
        setSelectedClassId(form.classes);
    }

}, [form.classes, classes]);


useEffect(() => {
    if (form.classes && form.section) {
        setSelectedClassId(form.classes);
        fetchSubjects();
    }
}, [form.classes, form.section]);


const fetchSubjects = async () => {
  if (!selectedClassId || !form.section) {
    setResponse2({ message: 'Please select class and section to load Subjects', status: 'error' });
    return;
  }

  try {
    setLoading(true);
    const res = await fetch(`https://api.kcian.in/fetch-assigned-subject?class_id=${selectedClassId}&section=${form.section}`);

    if (res.ok) {
      const data = await res.json();

      if(data.length > 0){
      setSubjects(data);

      setResponse2({ message: 'Assigned Subjects Fetched Successfully.', status: 'success' });
      }
      else {
        setSubjects([]);
        setResponse2({ message: 'No Subjects Assigned for this Class & Section.', status: 'error' });
      }
    } else {
      setResponse2({ message: 'Something Went Wrong. Please try again.', status: 'error' });
    }
  } catch (error) {
    console.error('Fetch assigned subjects error:', error);
  } finally {
    setLoading(false);
    setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
  }
};



    const handleChange = (e) => {
        const { name, value, files, type } = e.target;

        if (type === "file") {
            const file = files[0];
            if (file) {
                const fileSizeInMB = file.size / (1024 * 1024);
                if (fileSizeInMB > 2) {

                    setResponse2({ message: "File size is too large! Please upload a file smaller than 2MB.", status: 'error' });
                    e.target.value = null;
                    return;
                }


                setForm({
                    ...form,
                    [name]: file,
                });
            }
        } else {

            setForm({
                ...form,
                [name]: value,
            });
        }
    };



    const handleSubmit = async (e) => {
        e.preventDefault();

        const sendData = new FormData();

        for (const key in form) {
            if (form[key] !== null && form[key] !== undefined) {
                sendData.append(key, form[key]);
            }
        }


        setLoading(true);

        try {

            const res = await axios.post(
                "https://api.kcian.in/add-homework",
                sendData,
                { headers: { "Content-Type": "multipart/form-data" } }
            );
            setResponse2({ message: 'Homework Added Successfully.', status: 'success' });

            setForm({
                homework_date: '',
                year: '',
                submisssion_date: '',
                marks: '',
                description: '',
                classes: '',
                section: '',
                subject: '',
                file: null
            });
            if (fileInputRef.current) {
                fileInputRef.current.value = null;
            }

        } catch (err) {
            console.error("❌ Error:", err.response?.data || err.message);
            // setResponse2({ message: 'Something went wrong. Please try again.', status: 'error' });
        } finally {
            setLoading(false);
            setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
        }
    };

    return (
                        <section className='py-4'>
      <div className='px-4'>

      <HeadingArea message1='Homework' message2='Add Homework' />


                {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}

                <form onSubmit={handleSubmit} className="mt-5">   
                                         <div className="row">


                            <div className="col-md-4 mb-4">
                                <div className='profile-input-area'>
                                    <label className="profile-badge">Select AY*</label>
                                    <select
                                        className="profile-input"
                                        name="year"
                                        value={form.year}
                                        onChange={handleChange}
                                                                               required
                                    >
                                        <option value="">-- Select Academic Year --</option>
                                        {academicYears.map((ay) => (
                                            <option key={ay.year} value={ay.year}>
                                                {ay.year} --- {ay.title}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>



                            {/* Class Dropdown with Search */}
                            <div className="col-md-4 mb-4">
                                <div className="profile-input-area">
                                    <label className="profile-badge">Class*</label>

                                    <select
                                        className="profile-input"
                                        name='classes'
                                
                                        value={form.classes}
                                        onChange={handleChange}
                                       
                                        required
                                    >
                                        <option value="">-- Select Class --</option>
                                        {classes.map((cls) => (
                                            <option key={cls.id} value={cls.id}>
                                                {cls.class_name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>


                            {/* Section Dropdown with Search */}
                            <div className="col-md-4 mb-4">
                                <div className="profile-input-area">
                                    <label className="profile-badge">Section*</label>
                                    <select
                                        className="profile-input"
                                        name="section"
                                        value={form.section}
                                        onChange={handleChange}
                                        disabled={availableSections.length === 0}
                                        required
                                    >
                                        <option value="">-- Select Section --</option>
                                        {availableSections.map((section, idx) => (
                                            <option key={idx} value={section}>
                                                {section}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>


                                                        {/* Subject Dropdown with Search */}
                            <div className="col-md-4 mb-4">
                                <div className="profile-input-area">
                                    <label className="profile-badge">Subjects*</label>

                                    <select
                                        className="profile-input"
                                        name="subject"
                                        value={form.subject}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="">-- Select Subject --</option>
                                        {subjects.map((subj) => (
                                            <option key={subj.id} value={subj.sub_id}>
                                                {subj.sub_name} ({subj.sub_type}) &nbsp;&nbsp;---&nbsp;&nbsp; {subj.sub_code}
                                            </option>
                                        ))}
                                    </select>

                                </div>
                            </div>


                            {/* Homework-section */}
                            <div className="col-md-4 mb-4">
                                <div className="profile-input-area">
                                    <label htmlFor="homework" className="profile-badge">
                                        Homework Date*
                                    </label>
                                    <input
                                        type="date"
                                        id="homework"
                                        className="profile-input"
                                        name="homework_date"
                                        value={form.homework_date}
                                        onChange={handleChange}
                                required
                                    />
                                </div>
                            </div>

                            <div className="col-md-4 mb-4">
                                <div className="profile-input-area">
                                    <label htmlFor="submission" className="profile-badge">
                                        Submission Date*
                                    </label>
                                    <input
                                        type="date"
                                        id="submission"
                                        className="profile-input"
                                        name="submission_date"
                                        value={form.submission_date}
                                        required
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                            {/* Marks-section  */}

                            <div className="col-md-4 mb-4">
                                <div className="profile-input-area">
                                    <label className="profile-badge">Marks</label>
                                    <input
                                        type="number"
                                        className="profile-input"
                                        name="marks"
                                        value={form.marks}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>

                            {/* File-section */}
                            <div className="col-md-4 mb-4">
                                <div className="profile-input-area">
                                    <label className="profile-badge">File</label>
                                    <input
                                        type="file"
                                        className="profile-input bg-white"
                                        name="file"
                                        ref={fileInputRef}
                                        accept=".pdf, image/*" onChange={handleChange}
                                    />
                                </div>
                            </div>

                        </div>

                        {/*  */}
                            <div className="col-md-8 mb-4">
                            <div className="profile-input-area">
                                <label className="profile-badge mt-4">Description*</label>
                                <textarea className="profile-input"
                                    name="description"
                                    style={{height: '10em'}}
                                    value={form.description}
                                    onChange={handleChange}
                                    required
                                />

                            </div>
                        </div>
                    {/* Buttons */}
 <div className='col-12'>
                <button type='submit' className='profile-btn'><FaCheck /> SAVE</button>
              </div>
                </form>


        </div>
        </section>
    )
}

export default AddHomework